/**
 * Chat List API Contracts
 *
 * Types and Valibot schemas for the user chats list endpoint.
 * GET /api/resources/v1/chats
 *
 * Returns a paginated list of user's past chat sessions for the sidebar.
 * Chats are sorted by lastActivityMs (newest first).
 */
import * as v from 'valibot';

// ============================================
// Response Schemas
// ============================================

export const ChatListItemSchema = v.object({
  sessionId: v.string(),
  title: v.string(),
  lastActivityMs: v.number(),
});

export const ChatListDataSchema = v.object({
  userId: v.string(),
  chats: v.array(ChatListItemSchema),
  nextCursor: v.optional(v.nullable(v.number())),
  hasMore: v.boolean(),
});

export const ChatListResponseSchema = v.object({
  responseStatus: v.string(),
  data: ChatListDataSchema,
});

// ============================================
// Types
// ============================================

export type ChatListItem = v.InferOutput<typeof ChatListItemSchema>;

export type ChatListData = v.InferOutput<typeof ChatListDataSchema>;

export type ChatListResponse = v.InferOutput<typeof ChatListResponseSchema>;

// ============================================
// Request
// ============================================

export interface ChatListRequestParams {
  readonly limit?: number;
  readonly cursor?: number;
}
